module.exports = __webpack_public_path__ + "static/media/integral_card_1.e27084e9.png";